export default __webpack_public_path__ + "static/media/trash1-red.e0df2b32.svg";